<template>
    <v-layout row wrap class="quem">
        <v-flex class="titulo-centro">
            <h2> QUEM SOMOS  </h2>

            <div class="risquinho-centro"></div>

            <p>
                A <strong> Peccinin & Alessi Advocacia </strong>  nasceu do projeto de fornecer um atendimento especializado e pessoal a seus clientes em Direito Público e Privado, especialmente em Direito Civil, Tributário, Eleitoral e Parlamentar. Unindo anos de experiência de seus sócios, <strong>Luiz Eduardo Peccinin e Dylliardi Alessi</strong>, a banca conta com uma equipe especializada e dedicada ao cliente em primeiro lugar.</p>
            <p>
               Do pequeno ao grande assessorado, nosso objetivo é oferecer soluções dinâmicas e personalizadas aos problemas apresentados, desde a mesa de negociação até, se necessário o litígio, a decisão final do processo. Além disso, contamos com uma área específica para o Advocacy, com foco na representação de suas causas em processos de formulação e execução de políticas públicas e legislativas em todo o Brasil. 
            </p>
        </v-flex>
    </v-layout>
</template>

<script>
export default {

}
</script>

<style>

</style>
